import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Analytics } from "@vercel/analytics/react";
import Header from "./Base/Header";
import Footer from "./Base/Footer";
import Events from "./Events/Events";
import EventsDynamic from "./EventsDynamic/EventsDynamic";
import Matchmaking from "./EventsDynamic/Matchmaking";
import About from "./EventsDynamic/About";
import News from "./EventsDynamic/News";
import EventsPage from "./EventsDynamic/EventsPage";
import NonProfitSignUp from "./EventsDynamic/NonProfitSignUp";
import EmployeeSignUp from "./EventsDynamic/EmployeeSignUp";
import NavPagePlaceholder from "./EventsDynamic/NavPagePlaceholder";

import { setCookie } from "./utils";
import ApiService from "./services/ApiService";
import LoadingPage from "./Base/Loading";

function RedirectToExternalURL({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
}

export default function App() {
  // const homepage = process.env.REACT_APP_HOMEPAGE || "dynamic"; // temp should be ""
  const homepage = process.env.REACT_APP_HOMEPAGE || "";
  const [leadPage, setLeadPage] = useState(false);
  const [changeHead, setChangeHead] = useState(false);
  const [urlParams, setUrlParams] = useState(null);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState({});
  const [preloadedEvent, setPreloadedEvent] = useState(null);
  const [dynamicEvent, setDynamicEvent] = useState({
    "signupEmail": {
        "emailBody": "<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Hi {FirstName|\"There\"},</span>\n<br>\n<br>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Thank you for your interest in joining our Executive Dinner: Appetite for AI!</span>\n<br>\n<br>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">A team member will reach out to you if you are accepted into an event.</span>\n<br>\n<br>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Warm regards,</span>\n</div>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Shawn</span>\n</div>\n<div style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt\">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href=\"mailto:ihaq@landmarkventures.com\">ihaq@landmarkventures.com</a>    <br> \n    <br><a href=\"https://www.linkedin.com/in/xcuigmail/\">LinkedIn</a> | <a href=\"https://calendly.com/shawncui/30min\">Schedule a Meeting</a><br> _______________________________________\n</div>",
        "emailSendFrom": "ihaq@landmarkventures.com",
        "emailSendFromName": "Shawn Cui",
        "emailSubject": "Thanks for Applying | Executive Dinner: Appetite for AI"
    },
    "deniedEmail": {
        "emailBody": "<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Hi {FirstName|\"There\"},</span>\n<br>\n<br>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Thank you for your interest in joining Executive Dinner: Appetite for AI. Unfortunately we are at capacity for this event and so are unable to accomodate you.</span>\n<br>\n<br>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Warm regards,</span>\n</div>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Shawn</span>\n</div>\n<div style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt\">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href=\"mailto:ihaq@landmarkventures.com\">ihaq@landmarkventures.com</a>    <br> \n    <br><a href=\"https://www.linkedin.com/in/xcuigmail/\">LinkedIn</a> | <a href=\"https://calendly.com/shawncui/30min\">Schedule a Meeting</a><br> _______________________________________\n</div>",
        "emailSendFrom": "ihaq@landmarkventures.com",
        "emailSendFromName": "Shawn Cui",
        "emailSubject": "Executive Dinner: Appetite for AI at capacity"
    },
    "approvedEmail": {
        "emailSendFrom": "ihaq@landmarkventures.com",
        "emailSubject": "CONFIRMATION | Executive Dinner: Appetite for AI",
        "emailBody": "<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Hi {FirstName|\"There\"},</span>\n<br>\n<br>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;\">Thank you for your interest in joining our Executive Dinner: Appetite for AI! We are delighted to confirm your participation for the following event: </span>\n<br>\n<br>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">\n<p>\n  <ul class=\"glist\" style=\"margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;\" type=\"disc\">\n    <li>\n      <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt; color: #4472c4;\">\n        <strong>EXECUTIVE DINNER: APPETITE FOR AI</strong>\n      </span>\n      <br>\n      Thank you for your interest. John Kunschner, Head of Investment Banking at Landmark, will reach out directly to coordinate a time & place to meet.<br><br>\n    </li>\n  </ul>\n</p>\n</span>\n<span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">We will follow up shortly with your calendar invite(s). Looking forward to welcoming you there!</span>\n<br>\n<div>\n  <br>\n</div>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Best,</span>\n</div>\n<div>\n  <span style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">Shawn</span>\n</div>\n<div style=\"font-family: arial,helvetica,sans-serif; font-size: 10pt;\">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href=\"mailto:ihaq@landmarkventures.com\">ihaq@landmarkventures.com</a>    <br> \n    <br><a href=\"https://www.linkedin.com/in/xcuigmail/\">LinkedIn</a> | <a href=\"https://calendly.com/shawncui/30min\">Schedule a Meeting</a><br> _______________________________________\n</div>",
        "emailSendFromName": "Shawn Cui"
    },
    "_id": "66d0b612476d6c268c2190f3",
    "title": "Glean DMV",
    "pageUrl": "glean-dmv",
    "pageContent": {
        "eventImages": [
            "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1725463168-churchill-1-2.png"
        ],
        "expectBullets": [
            "6:00 - 7:00 pm: Cocktails & Networking",
            "7:00 - 7:30 pm: Around the Room Introductions",
            "7:30 - 9:00 pm: Dinner & Discussion"
        ],
        "footerImages": [],
        "_id": "66ec5a73fa3f14bdbae545ed",
        "headerLogos": [
            {
                "_id": "66ec5a73fa3f14bdbae545e7",
                "src": "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1725297444-google-cloud-logo.png",
                "scale": 100
            },
            {
                "_id": "66ec5a73fa3f14bdbae545e8",
                "src": "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1724954116-glean_logomark_2024.png",
                "scale": 60
            }
        ],
        "faqs": [
            {
                "_id": "66ec5a73fa3f14bdbae545e9",
                "question": "Is the dinner complimentary?",
                "answer": "Yes, all costs are fully covered - we're delighted to host you as one of our guests."
            },
            {
                "_id": "66ec5a73fa3f14bdbae545ea",
                "question": "Can I bring a plus one?",
                "answer": "Due to limited capacity, this event is exclusively invitation-only. We are happy to check in on plus ones on an individual basis. If you'd like to inquire about inviting a colleague, please contact jpatterson@landmarkventures.com to check on availability."
            },
            {
                "_id": "66ec5a73fa3f14bdbae545eb",
                "question": "Is there parking at the venue?",
                "answer": "As each venue has different parking arrangements, we'll be sure to include all the relevant parking details in the calendar hold and event reminders."
            },
            {
                "_id": "66ec5a73fa3f14bdbae545ec",
                "question": "Who do I reach out to if I have further questions?",
                "answer": "Please reach out to ihaq@landmarkventures.com if you have any questions ahead of the event."
            }
        ],
        "heroHeading": "Executive Dinner: Appetite for AI",
        "heroSubHeading": "Join us on October 1st at American Prime, for a wonderful evening hosted in partnership with Google Cloud and Glean.",
        "heroText": "This special VIP Event (invitation-only; complimentary) brings together an exclusive group of 20-25 Senior Technology Leaders for an insightful conversation around the trends, challenges, and opportunities related to harnessing and maximizing Generative AI. Details as follows:",
        "eventDate": "Tuesday, October 1st",
        "eventTime": "6:00pm - 9:00pm EST",
        "eventLocationFull": "American Prime\n(Private Room)\n1420 Spring Hill Rd\nMcLean, VA 22102",
        "eventLocationShort": "McLean, VA",
        "afterSubmittedText": "A member of our team will be in touch shortly confirming your attendance.",
        "expectText": "Upon registering, our team will follow up with a formal confirmation and calendar hold with more details."
    },
    "owners": [
        {
            "_id": "66ec5a73fa3f14bdbae545e5",
            "email": "ihaq@landmarkventures.com",
            "assignedTime": 1726604563
        },
        {
            "_id": "66ec5a73fa3f14bdbae545e6",
            "email": "adijamco@landmarkventures.com",
            "assignedTime": 1726765679
        }
    ],
    "eventId": "d1710d2f",
    "createdTime": 1724954131,
    "__v": 12,
    "apolloAutofill": true,
    "googlePolicyOptions": true,
    "referralUrls": [
        {
            "_id": "66e1d8698de953218a9325bd",
            "url": "event",
            "name": "Glean"
        }
    ],
    "sheetId": "274515867",
    "googleSheetHeadersVersion": 1
});
  const [dynamicEventReferral, setDynamicEventReferral] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  console.log("HOMEPAGE", homepage);
  console.log(`window.location.pathname`, window.location.pathname);
  console.log(`urlParams`, urlParams);

  const isOnDynamicEventPage =
    dynamicEvent && dynamicEvent.eventId ? true : false;

  // useEffect(() => {
  //   async function getDynamicEvent() {
  //     try {
  //       let pageUrl = "glean-dmv"
  //       let  referral = false;
 
  //       const api = new ApiService();
  //       console.log(`getDynamicEvent() - pageUrl`, pageUrl);
  //       const event = await api.post(
  //         `landmark/dynamicEvents/getEventByPageUrl`,
  //         { pageUrl }
  //       );
  //       console.log(
  //         `getDynamicEvent() - landmark/dynamicEvents/getEventByPageUrl`,
  //         event
  //       );
  //       if (event && event.pageUrl) {
  //         // dynamic event for this page url has been found
  //         setDynamicEvent(event);
  //         console.log(`Dynamic Event for this page url has been found`);
  //         console.log(`setDynamicEvent()`, event);

  //         if (referral) {
  //           // console.log(`possible referral detected - ${referral}`);
  //           // possible referral url - check event to see if the referral url is included
  //           if (event.referralUrls && event.referralUrls.length) {
  //             const eventReferral = event.referralUrls.find(
  //               (r) =>
  //                 r.url.toLowerCase().trim() === referral.toLowerCase().trim()
  //             );
  //             if (eventReferral) {
  //               console.log(`referral: ${eventReferral.name}`);
  //               setDynamicEventReferral({
  //                 url: eventReferral.url,
  //                 name: eventReferral.name,
  //               });
  //             }
  //           }
  //         } else {
  //           // console.log(`no referral detected`);
  //         }
  //         // setUser(response);
  //       } else {
  //         throw `Couldn't get dynamic event by pageUrl`;
  //       }
  //     } catch (error) {
  //       console.log(`error`, error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   getDynamicEvent();
  // }, []);

  useEffect(() => {
    try {
      // Get the current URLSearchParams object from the window.location
      const params = new URLSearchParams(window.location.search);

      // Create an empty object to store the parsed parameters
      const parsedParams = {};

      // Loop through all the URL parameters and store them in the parsedParams object
      for (const [key, value] of params.entries()) {
        parsedParams[key] = value;
      }

      // set cookies
      const userId = parsedParams["u"];
      if (userId) {
        console.log(`setting userId cookie`, userId);
        setCookie("userId", userId);
        setUserId(userId);
      }

      // Set the parsed parameters in the state
      setUrlParams(parsedParams);
    } catch (error) {
      console.log(`error`, error);
    }
  }, []);

  useEffect(() => {
    async function getUserInfo() {
      try {
        const api = new ApiService();
        const response = await api.get(
          `landmark/contacts/getContact/${userId}`
        );
        console.log(
          `getUserInfo() - landmark/contacts/getContact/${userId}`,
          response
        );
        if (response && response.contactId) {
          setUser(response);
        } else {
          throw `Couldn't get user from userId ${userId}`;
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
    if (userId) {
      getUserInfo();
    }
  }, [userId]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealSelector = [
      ".events-wrapper > *",
      ".cannes-wrapper > *",
      ".ces-wrapper > *",
      ".ed-main > *",
      ".portal-page > *",
      "footer",
      ".auto__container > *",
      ".main section",
      ".main .section",
      ".main .content-block",
      ".main .reveal-on-scroll",
    ].join(",");

    let observer = null;
    const applyRevealClasses = () => {
      const nodes = document.querySelectorAll(revealSelector);
      let revealIndex = 0;

      nodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.classList.contains("motion-reveal")) return;
        if (node.closest(".modal, .rsvp-modal")) return;
        if (node.closest(".position-fixed")) return;
        const isFooterNode = node.matches("footer");
        if (!isFooterNode && node.closest("footer")) return;

        node.classList.add("motion-reveal");
        if (isFooterNode) {
          node.style.setProperty("--motion-translate-y", "0px");
        }
        node.style.setProperty("--motion-delay", `${Math.min(revealIndex * 40, 220)}ms`);
        revealIndex += 1;

        if (reduceMotion || !observer) {
          node.classList.add("motion-reveal--visible");
          return;
        }

        const rect = node.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const isAlreadyInView = rect.top < viewportHeight * 0.92 && rect.bottom > 0;

        if (isAlreadyInView) {
          node.classList.add("motion-reveal--visible");
          return;
        }

        observer.observe(node);
      });
    };

    if (!reduceMotion) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("motion-reveal--visible");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.12,
          rootMargin: "0px 0px -8% 0px",
        }
      );
    }

    const initTimer = window.setTimeout(applyRevealClasses, 80);
    const secondPassTimer = window.setTimeout(applyRevealClasses, 450);

    return () => {
      window.clearTimeout(initTimer);
      window.clearTimeout(secondPassTimer);
      if (observer) observer.disconnect();
    };
  }, [location.pathname, dynamicEvent?.eventId]);


  let shouldShowHeader = true;
  let shouldShowFooter = true;
  let headerProps = {
    sticky: true,
    transparent: false,
    cssClass: "position-fixed",
  };
  let footerProps = {
    backgroundColor: `#ffffff`,
    fullLengthDivider: false,
  };

  const isOnPage = (page) => {
    if (
      window.location.pathname
        .toLowerCase()
        .includes(`/${page.toLowerCase()}`) ||
      homepage === page.toLowerCase()
    ) {
      return true;
    }
    return false;
  };

  // const isOnDynamicPage = (page) => {
  //   if (
  //     window.location.pathname.includes(page.toLowerCase()) ||
  //     homepage === page.toLowerCase()
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };
  // this checks the env variables to determine which page is being rendered
  // let shouldShowHeaderFooter =
  //   homepage !== "sisdelegate" && homepage !== "leadgen";
  // however when running locally env variables may not be set, in which case check pathname
  if (
    isOnDynamicEventPage
  ) {
    shouldShowHeader = false;
    shouldShowFooter = false;
  }
 
  console.log(`shouldShowHeader`, shouldShowHeader);
  console.log(`shouldShowFooter`, shouldShowFooter);

  console.log('dynamicEvent', dynamicEvent);

  if (loading) {
    return <LoadingPage />; // Display loading component while fetching data
  }

  return (
    <>
      <Toaster
        containerStyle={{
          top: 100,
        }}
        toastOptions={{
          style: {
            background: "#175d8c",
            color: "#fff",
          },
        }}
      />
      {shouldShowHeader && <Header headerProps={headerProps} />}
      <div
        className={
          "main " + (leadPage || isOnDynamicEventPage ? "removeP" : "")
        }
      >
        <Routes>
            {dynamicEvent && <Route
              path="/"
              element={<EventsDynamic event={dynamicEvent} />}
            />}

            {dynamicEvent && <Route
              path="/portal"
              element={<Matchmaking event={dynamicEvent} />}
            />}
            {dynamicEvent && <Route
              path="/about"
              element={<About />}
            />}
            {dynamicEvent && <Route
              path="/news"
              element={<News />}
            />}
            {dynamicEvent && <Route
              path="/events"
              element={<EventsPage />}
            />}
            {dynamicEvent && <Route
              path="/success-stories"
              element={<NavPagePlaceholder title="Success Stories" currentPage="success-stories" />}
            />}
            {dynamicEvent && <Route
              path="/nonprofit-signup"
              element={<NonProfitSignUp event={dynamicEvent} />}
            />}
            {dynamicEvent && <Route
              path="/employee-signup"
              element={<EmployeeSignUp event={dynamicEvent} />}
            />}

        </Routes>
      </div>
      <Analytics />
      {shouldShowFooter && <Footer footerProps={footerProps} />}
    </>
  );
}
